<template>
  <AnalyticsTemplate 
    page-title="桥梁VHF统计"
    chart-type="vhf"
  />
</template>

<script>
import AnalyticsTemplate from './AnalyticsTemplate.vue'

export default {
  name: 'VhfAnalytics',
  components: {
    AnalyticsTemplate
  }
}
</script>
